<template>
  <div id="home_notice" class="list_box2">
    <table>
      <tr v-for="(notice,index) in notices" :key="index" style="border-bottom:#ddd 1px dashed;" v-if="notice.isTop">
        <th style="padding:16px 0; width: 100px;">{{notice.sDate && notice.sDate.split(' ')[0]}}</th>
        <th style="padding:16px 0;"></th>
        <td style="padding:10px 0;">
          <router-link :to="{ name: 'ann_page' ,params: {newsid: notice.id}}">{{notice.title}}<img src="/../static/images/stickyPin.png"></router-link>
        </td>
      </tr>
      <tr v-for="(notice,index) in notices" :key="index" style="border-bottom:#ddd 1px dashed;" v-if="!notice.isTop">
        <th style="padding:16px 0; width: 100px;">{{notice.sDate && notice.sDate.split(' ')[0]}}</th>
        <th style="padding:16px 0;"></th>
        <td style="padding:10px 0;">
          <router-link :to="{ name: 'ann_page' ,params: {newsid: notice.id}}">{{notice.title}}</router-link>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
export default {

  name: 'home_notice',

  data() {
    return {
      notices: [],
    }
  },
  created() {

    this.init();
  },
  methods: {
    init() {
      this.getNoticeData();
    },
    getNoticeData() {
      axios.get(API.rent_notice)
        .then(response => {
          for (var i = response.data.length - 1; i >= 0; i--) {
            this.notices.push(response.data[i])
          }
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
  }
}

</script>
<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// HomeNotice.vue?1c5a6562